/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { ssoService } from '../../api/services/ssoService';
import { user_login, user_logout } from '../../infra/aggregates/authSlice';
import {
  removeAuthToken,
  setAuthToken,
} from '../../infra/aggregates/authTokenSlice';
import { useAppDispatch } from '../../infra/hooks';
import AuthInterface from '../../infra/aggregates/AuthInterface';

import { useNavigate } from 'react-router-dom';
import { setLoading } from '../../infra/aggregates/LoaderSlice';
import {
  setHRView,
  setIsOnlyAttendanceView,
  setLogOutBtn,
} from '../../infra/aggregates/myProfile/isHRViewSlice';
import { commonServices } from '../../api/services/commonServices';
import { setUserProfilePic } from '../../infra/aggregates/profilePicSlice';
import { changeApplang } from '../../common/configs/utils';
import { useTranslation } from 'react-i18next';
import { seEmpStatus } from '../../infra/aggregates/empStatusSlice';
import { userService } from '../../api/services/userService';
import { setEmployeeCompanyData } from '../../infra/aggregates/employeeCompanySlice';
import { resetClockOut } from '../../infra/aggregates/clockOutSlice';
import {
  resetCanClockIn,
  resetClockIn,
} from '../../infra/aggregates/clockInSlice';

import { setAuthPermission } from '../../infra/aggregates/authPermissionSlice';
import { resetPersonalInfo } from '../../infra/aggregates/myProfile/personalInfoSlice';
import { useCreate } from '../../api';
import { setIsViewAsSuperAdmin } from '../../infra/aggregates/viewAsSuperAdminSlice';
import { useQuery } from 'react-query';
import { setAdminId } from '../../infra/aggregates/adminIdSlice';

const DTOSSO = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();

  const { mutateAsync, data, isLoading } = useCreate({
    url: 'auth/employee-portal/login-with-token',
    axiosConfig: {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });

  const viewAsSuperAdminHeader = { 'X-View-As-Super-Admin': true };

  async function callSSO(
    empId: number,
    token: any,
    set_view?: any,
    _lang?: any,
  ) {
    dispatch(setLoading(true));
    localStorage.setItem('emplang', _lang);
    i18n.changeLanguage(_lang);
    changeApplang(_lang, false);

    if (token && !data && !isLoading) {
      const result: any = await mutateAsync({
        portalToken: token,
      });

      if (!result) return;

      dispatch(setAdminId(result?.data?.adminPortalAuthUserId));

      dispatch(setIsViewAsSuperAdmin({ isViewAsSuperAdmin: true }));
      await ssoService
        .gotoEmployee(empId, {
          headers: viewAsSuperAdminHeader,
        })
        .then((response: any) => {
          if (response) {
            const user_obj: AuthInterface = {
              user_id: response?.user?.id,
              name:
                response?.employee?.first_name +
                ' ' +
                response?.employee?.last_name,
              username: response?.user?.username,
              profile_pic: response?.user?.profile_pic,
              email: response?.user?.email,
              status: response?.user?.status,
              company_id: response.company,
              designaion: response.designation?.name,
              department: response.department?.name,
              emp_id: response.employee?.id,
              department_id: response.department?.id,
              staff_id: response?.employee?.staff_id,
              hire_date: response?.employee?.emp_job_detail?.hire_date,
              currency: response?.currency?.name,
            };
            dispatch(user_login(user_obj));
            dispatch(setAuthPermission(response?.user_roles));
            dispatch(setAuthToken(true));

            if (response?.user?.id) {
              commonServices
                .getFullPathProfilePic(response?.user?.id, {
                  headers: viewAsSuperAdminHeader,
                })
                .then((getProfilePic: any) => {
                  if (getProfilePic?.response == 'success') {
                    dispatch(
                      setUserProfilePic(getProfilePic?.data?.profile_pic),
                    );
                  }
                });
            }
            if (response.employee?.id && response.company) {
              getCurrentEmpStatus(response.employee?.id, response.company);
            }

            if (response.company) {
              getCompanyLogo(response.company);
            }

            if (set_view) {
              navigate({
                pathname: '/employeeAttendance',
              });
            } else {
              navigate({
                pathname: '/employeePersonalDetails',
              });
            }

            dispatch(setLoading(false));
          } else {
            dispatch(setLoading(false));
            return;
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          console.log(err);
        });
    } else {
      navigate({ pathname: '/login' });
    }
  }

  async function getCurrentEmpStatus(empId: any, compId: any) {
    dispatch(setLoading(true));

    commonServices
      .getCurrentEmpStatus(empId, compId, { headers: viewAsSuperAdminHeader })
      .then((res: any) => {
        if (res.response == 'success') {
          dispatch(setLoading(false));

          dispatch(seEmpStatus(res?.data == 1 ? true : false));
        }
      })
      .catch((err) => {
        console.log('err while getting emp status in the SSO page', err);

        dispatch(setLoading(false));
      });
  }
  async function getCompanyLogo(companyId: any) {
    await userService
      .getCompanDetail(companyId, { headers: viewAsSuperAdminHeader })
      .then((response: any) => {
        if (response.response == 'success') {
          dispatch(setEmployeeCompanyData({ logo: response?.data?.logo }));
        }
      })
      .catch((err) =>
        console.log('error while getting company detail for employee', err),
      );
  }
  useEffect(() => {
    dispatch(resetPersonalInfo());
    dispatch(resetClockOut());
    dispatch(resetCanClockIn());
    dispatch(resetClockIn());
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const emp_id = urlParams.get('id');

    const _getToken = urlParams.get('token');
    const _getPortal = urlParams.get('portal');
    const _getLogOutBtnStatus = urlParams.get('logOutBtn');
    const _getView = urlParams.get('view');
    const _locale = urlParams.get('locale');
    const _lang = _locale ? _locale : 'en';

    //SSO Implementation

    if (_getPortal == 'false') {
      dispatch(setHRView(true));
    } else {
      dispatch(setHRView(false));
    }
    if (_getLogOutBtnStatus == 'false') {
      dispatch(setLogOutBtn(false));
    } else {
      dispatch(setLogOutBtn(true));
    }
    if (emp_id && _getView == null) {
      dispatch(user_logout());
      dispatch(removeAuthToken());
      localStorage.clear();
      dispatch(setIsOnlyAttendanceView(false));

      callSSO(Number(emp_id), _getToken, null, _lang);
    } else if (emp_id && _getView == 'Attendance') {
      const set_view = '/employeeAttendance';
      dispatch(setIsOnlyAttendanceView(true));
      callSSO(Number(emp_id), _getToken, set_view, _lang);
    }
  }, []);

  return <></>;
};

export default DTOSSO;
